import React from 'react';

import { StyledAvatar } from './style';

const UserAvatar = ({ avatar }) => <StyledAvatar src={avatar} />;

export default UserAvatar;
